import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=2a7ed822"
import script from "./Standard.vue?vue&type=script&lang=js"
export * from "./Standard.vue?vue&type=script&lang=js"
import style0 from "./Standard.vue?vue&type=style&index=0&id=2a7ed822&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports